var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { class: { "md-invalid": _vm.errorMessage } },
    [
      _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "md-select",
        {
          attrs: {
            disabled: _vm.disabled,
            multiple: _vm.multiple,
            required: _vm.required,
            value: _vm.value,
          },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event)
            },
            "md-opened": function ($event) {
              return _vm.$emit("open")
            },
            "md-selected": function ($event) {
              return _vm.$emit("select", $event)
            },
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }